import { Link } from "react-router-dom/cjs/react-router-dom.min";
import logoimages from "../../../images/logo_1.png";
import Logo1 from "../../../images/Screenshot_1.png";

import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showToast } from "../../toast";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import {
  getAllUserSessions,
  getAllUserTeamViews,
  getSingleUserSessions,
  getSingleUserTeamViews,
  getSummary,
  userLogout,
} from "../../../api";
import { logoutUser } from "../../../app/features/userSlice";
import SummaryCards from "./SummaryCards";
import moment from "moment";
import BaseTable from "../data-table/BaseTable";
import { Clear, Visibility } from "@material-ui/icons";
import { AnonUserAnalysis } from "./AnonUserAnalysis";

const UserEngagement = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [summary, setSummary] = useState({
    total_users: 0,
    avg_session_duration_minutes: 0,
    total_team_views: 0,
    total_team_updates: 0,
  });

  // details for cards
  useEffect(() => {
    async function fetchSummary() {
      try {
        setLoading(true);
        const response = await getSummary();
        if (response.status === 200) {
          setSummary(response.data?.data);
        }
      } catch (error) {
        // Optionally, you can show an error message to the user
      } finally {
        setLoading(false);
      }
    }
    fetchSummary();
  }, []);

  // <!-- tanstack table related states and functions -->
  const [userSessions, setUserSessions] = useState([]);
  const [singleUserSessions, setSingleUserSessions] = useState([]);
  const [singleUserTeamViews, setSingleUserTeamViews] = useState([]);
  const [teamViews, setTeamViews] = useState([]);
  const [userName, setUserName] = useState("");
  const [currentTab, setCurrentTab] = useState("userSessions");
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleUserSessionView = async (userId, username) => {
    try {
      setIsDialogOpen(true);

      setUserName(username || "");

      const response = await getSingleUserSessions({
        userId,
      });

      if (response.status === 200) {
        setSingleUserSessions(response?.data?.data);
      }
    } catch (error) {
      setIsDialogOpen(false);
      showToast("Something went wrong", 500);
    }
  };

  const handleUserTeamView = async (userId, username) => {
    try {
      setIsDialogOpen(true);
      setUserName(username || "");

      const response = await getSingleUserTeamViews({
        userId,
      });

      if (response.status === 200) {
        setSingleUserTeamViews(response?.data?.data);
      }
    } catch (error) {
      setIsDialogOpen(false);
      showToast("Something went wrong");
    }
  };

  /** @type import('@tanstack/react-table').ColumnDef<any>[]*/
  const sessionColumns = [
    {
      accessorKey: "username",
      header: "Username",
      enableSorting: true,
    },
    {
      accessorKey: "email",
      header: "Email",
      enableSorting: true,
    },
    {
      accessorKey: "last_active",
      header: "Last Active (UTC)",
      enableSorting: true,
      cell: ({ row }) => {
        const data = row.original;
        return (
          <span>
            {data.last_active
              ? moment.utc(data.last_active).format("MM/DD/YYYY HH:mm:ss")
              : "-"}
          </span>
        );
      },
    },
    {
      accessorKey: "total_sessions",
      header: "Total Session",
      enableSorting: true,
      cell: ({ row }) => {
        return <span>{row.original.total_sessions}</span>;
      },
    },
    {
      accessorKey: "avg_session_minutes",
      header: "Avg Session Minutes",
      enableSorting: true,
      cell: ({ row }) => {
        return <span>{row.original.avg_session_minutes} mins</span>;
      },
    },
    {
      accessorKey: "avg_idle_minutes",
      header: "Avg Idle Minutes",
      enableSorting: true,
      cell: ({ row }) => {
        return <span>{row.original.avg_idle_minutes} mins</span>;
      },
    },
    {
      accessorKey: "total_active_minutes",
      header: "Total Active Minutes",
      enableSorting: true,
      cell: ({ row }) => {
        return <span>{row.original.total_active_minutes} mins</span>;
      },
    },
    {
      accessorKey: "total_idle_minutes",
      header: "Total Idle Minutes",
      enableSorting: true,
      cell: ({ row }) => {
        return <span>{row.original.total_idle_minutes} mins</span>;
      },
    },
    {
      id: "actions",
      enableSorting: false,
      cell: ({ row }) => {
        const data = row.original;
        return (
          <div
            onClick={() => handleUserSessionView(data.user_id, data.username)}
          >
            <Visibility
              style={{
                color: "#E5007D",
                width: "18px",
                height: "18px",
                cursor: "pointer",
              }}
            />
          </div>
        );
      },
    },
  ];

  /** @type import('@tanstack/react-table').ColumnDef<any>[]*/
  const singleUserSessionColumns = [
    {
      accessorKey: "sessionStart",
      header: "Session Start",
      cell: ({ row }) => {
        return (
          <span>
            {moment
              .utc(row.original.sessionStart)
              .format("MM/DD/YYYY HH:mm:ss")}
          </span>
        );
      },
    },
    {
      accessorKey: "sessionEnd",
      header: "Session End",
      cell: ({ row }) => {
        return (
          <span>
            {moment.utc(row.original.sessionEnd).format("MM/DD/YYYY HH:mm:ss")}
          </span>
        );
      },
    },
    {
      accessorKey: "reason",
      header: "Reason",
      cell: ({ row }) => {
        return (
          <span>{row.original.reason.split("_").join(" ").toUpperCase()}</span>
        );
      },
    },
    {
      accessorKey: "durationMinutes",
      header: "Duration Minutes",
      cell: ({ row }) => {
        return <span>{row.original.durationMinutes} mins</span>;
      },
    },
    {
      accessorKey: "inactiveMinutes",
      header: "Inactive Minutes",
      cell: ({ row }) => {
        return <span>{row.original.inactiveMinutes} mins</span>;
      },
    },
  ];

  /** @type import('@tanstack/react-table').ColumnDef<any>[]*/
  const teamViewColumns = [
    {
      accessorKey: "username",
      header: "Username",
    },
    {
      accessorKey: "email",
      header: "Email",
    },
    {
      accessorKey: "viewCount",
      header: "View Count",
    },
    {
      accessorKey: "editCount",
      header: "Edit Count",
    },
    {
      accessorKey: "viewEditRatio",
      header: "View/Edit Ratio",
    },
    {
      id: "actions",
      enableSorting: false,
      cell: ({ row }) => {
        const data = row.original;
        return (
          <div onClick={() => handleUserTeamView(data.user_id, data.username)}>
            <Visibility
              style={{
                color: "#E5007D",
                width: "18px",
                height: "18px",
                cursor: "pointer",
              }}
            />
          </div>
        );
      },
    },
  ];

  /** @type import('@tanstack/react-table').ColumnDef<any>[]*/
  const singleUserTeamViewsColumns = [
    {
      accessorKey: "teamName",
      header: "Team Name",
    },
    {
      accessorKey: "region",
      header: "Region",
    },
    {
      accessorKey: "tournamentName",
      header: "Tournament",
    },
    {
      accessorKey: "teamViewCount",
      header: "Team View Count",
    },
    {
      accessorKey: "teamUpdateCount",
      header: "Team Update Count",
    },
  ];

  const getCurrentTabData = () => {
    switch (currentTab) {
      case "userSessions":
        return userSessions;
      case "teamViews":
        return teamViews;
      default:
        return [];
    }
  };

  const getCurrentTabColumns = () => {
    switch (currentTab) {
      case "userSessions":
        return sessionColumns;
      case "teamViews":
        return teamViewColumns;
      default:
        return [];
    }
  };

  async function fetchSesisonData() {
    try {
      setLoading(true);
      const response = await getAllUserSessions({});

      if (response.status === 200) {
        setUserSessions(response?.data?.data);
      }
    } catch (error) {
      // Optionally, you can show an error message to the user
    } finally {
      setLoading(false);
    }
  }

  async function fetchTeamViews() {
    try {
      setLoading(true);
      const response = await getAllUserTeamViews();
      if (response.status === 200) {
        setTeamViews(response?.data?.data);
      }
    } catch (error) {
      // Optionally, you can show an error message to the user
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    async function fetchData() {
      if (currentTab === "userSessions") {
        await fetchSesisonData();
      } else {
        await fetchTeamViews();
      }
    }
    fetchData();
  }, [currentTab]);

  const handleLogout = async () => {
    const response = await userLogout();

    if (response?.status === 200) {
      dispatch(logoutUser());
      showToast(response?.data?.message, response?.status);
      history.push({
        pathname: "/login",
      });
    }
  };
  return (
    <>
      <div className="sectionlanding">
        {loading ? (
          <div className="loader-container">
            <div className="spinner"></div>
            <img
              src={logoimages}
              alt="logo"
              style={{ width: 100, height: 100 }}
            />
          </div>
        ) : (
          <div className="contenorlanding">
            <div className="col-12 contentrow">
              <div className="col-2 nevcolumn">
                <div className="nevlogo">
                  <img className="photoimagelanding" src={Logo1} alt="logo" />
                </div>
                <div className="nevlistst">
                  <li className="listnevbars">
                    <Link
                      to="/players-list"
                      className="text-black text-decoration-none"
                    >
                      Player List
                    </Link>
                  </li>

                  <div
                    className="accordion accordion-flush"
                    id="accordionExample"
                  >
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingOne">
                        <button
                          style={{ fontSize: "16px" }}
                          className="listnevbars bg-white p-0 shadow-none text-black accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          Tournament
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        className="collapse accordion px-2 show"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="d-flex flex-row align-items-center justify-content-start p-0 rounded-circle accordion-body gap-2 px-2">
                          <Link
                            to="/tournament-list"
                            className="text-black text-decoration-none px-2"
                          >
                            <span style={{ fontSize: "14px" }}>List</span>
                          </Link>
                        </div>
                        <div className="d-flex flex-row align-items-center justify-content-start p-0 rounded-circle accordion-body gap-2 px-2">
                          <Link
                            to="/create-tournament"
                            className="text-black text-decoration-none text-sm px-2"
                          >
                            <span style={{ fontSize: "14px" }}>Create</span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  <li className="listnevbars">
                    <Link
                      to="/user-stats"
                      className="text-black text-decoration-none"
                    >
                      Users
                    </Link>
                  </li>

                  <li className="listnevbars">
                    <Link
                      to="/user-engagement"
                      className="text-black text-decoration-none"
                    >
                      User Engagement
                    </Link>
                  </li>
                </div>
              </div>
              <div
                className="col-10 screensection"
                style={{ height: "auto", background: "#F8F8F8" }}
              >
                <div className="col-12 landingRow mb-4">
                  <div className="p-0 nevbarbutton">
                    <button
                      className="m-0 nevbarlogbutton"
                      onClick={() => handleLogout()}
                    >
                      Logout
                    </button>
                  </div>
                </div>
                <div className="bg-white p-2 landingsscreens">
                  <div className="landingscreen px-4">
                    {/* Cards */}
                    <div className="container text-center mt-3">
                      <div>
                        <SummaryCards summary={summary} />
                      </div>
                    </div>

                    {/* Anonymous User Analysis */}
                    <div className="text-center mt-5 mb-5">
                      <AnonUserAnalysis loading={tableLoading} />
                    </div>

                    {/* Tabs */}
                    <div className="col-12 d-flex flex-column gap-2 landing-box pt-3">
                      <ul className="d-flex flex-row nav nav-pills align-items-center justify-content-center">
                        <li className="nav-item">
                          <button
                            className={`nav-link ${
                              currentTab === "userSessions" ? "active-btn" : ""
                            }`}
                            aria-current="page"
                            onClick={() => {
                              setCurrentTab("userSessions");
                              setSingleUserSessions([]);
                            }}
                          >
                            Session Tracking
                          </button>
                        </li>
                        <li className="nav-item">
                          <button
                            className={`nav-link ${
                              currentTab === "teamViews" ? "active-btn" : ""
                            }`}
                            onClick={() => {
                              setCurrentTab("teamViews");
                              setSingleUserSessions([]);
                            }}
                          >
                            Team View Analysis
                          </button>
                        </li>
                      </ul>
                    </div>

                    {/* Table */}
                    <div className="card mt-5 shadow">
                      <div className="card-body">
                        <BaseTable
                          data={getCurrentTabData()}
                          columns={getCurrentTabColumns()}
                          paginationRequired={true}
                          searchRequired={true}
                          sortingRequired={true}
                          heading="User Engagement"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Dialog */}
      {isDialogOpen && (
        <div className="popup-overlay">
          <div
            className="popup-content"
            style={{ border: "1px solid #E5007D" }}
          >
            <div class="">
              <div class="d-flex modal-header justify-content-end rounded text-end sticky-top">
                <Clear
                  className="bg-danger border rounded text-white"
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsDialogOpen(false)}
                />
              </div>
              <div class="modal-body"></div>
              <div class="d-flex flex-column align-items-md-center justify-content-md-between gap-3 mt-4">
                <div className="w-100">
                  {currentTab === "userSessions" ? (
                    <BaseTable
                      columns={singleUserSessionColumns}
                      data={singleUserSessions}
                      heading={userName || ""}
                    />
                  ) : (
                    <BaseTable
                      columns={singleUserTeamViewsColumns}
                      data={singleUserTeamViews}
                      heading={userName || ""}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Dialog */}
    </>
  );
};

export default UserEngagement;
